import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { AppState, reducer as appReducer } from './app/app.reducers';
import { AuthState, reducer as authReducer } from './auth/auth.reducers';
import { RouterStateUrl } from './router/router.reducers';
import {
  reducer as translationReducer,
  TranslationState
} from './translation/translation.reducers';
import {
  ConstantsState,
  reducer as constantsReducer
} from './constants/constants.reducers';
import {
  MessengerState,
  reducer as messengerReducer
} from './messenger/messenger.reducer';
import {
  DistrictState,
  reducer as districtReducer
} from './district/district.reducer';

export interface BaseState {
  app: AppState;
  auth: AuthState;
  router: RouterReducerState<RouterStateUrl>;
  translations: TranslationState;
  constants: ConstantsState;
  messenger: MessengerState;
  districts: DistrictState;
}

export const reducers: ActionReducerMap<BaseState> = {
  app: appReducer,
  auth: authReducer,
  router: routerReducer,
  translations: translationReducer,
  constants: constantsReducer,
  messenger: messengerReducer,
  districts: districtReducer
};

export const getBaseState = createFeatureSelector<BaseState>('infrastructure');
